<template>
  <div class="syj_BlacktwoPrize syj_page-width">
    <title class="commom-title"><span>二等奖</span></title>
    <div class="syjprice_money"><span>奖金</span>￥{{ twoprizemoney }}</div>
    <div v-if="twoprizemoney == 0" class="lunkong">很遗憾，该奖项轮空啦～</div>
    <ul
        v-else
        class="winner-list"
        :class="blackresultTwo.length > 2 ? 'col-3' : ''"
    >
      <li
          class="winner-item"
          v-for="(item, index) in blackresultTwo"
          :key="index"
      >
        <div class="avatar">
          <img :src="item.avatar_url"/>
        </div>
        <div class="info">
          <div class="row">
            <div class="name">{{ item.name }}</div>
            <div class="number-info">
              <span class="title">中奖号码</span>
              <span class="number">{{ item.award_number }}</span>
            </div>
          </div>
          <div class="commitment">{{ item.order_commitment }}</div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "BlacktwoPrize",
  data() {
    return {};
  },
  props: {
    twoprizemoney: {
      type: [Number, String],
      default: ""
    },
    blackresultTwo: {
      type: Array,
      default: () => []
    }
  },
  mounted() {
  },
  methods: {},
};
</script>

<style lang="less" scoped>
@import "./style.less";

.syjprice_money {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  font-weight: 700;
  margin-top: 30px;
  color: #fff;
  
  span {
    font-size: 24px;
    margin-top: 4px;
    color: #dd0e19;
  }
}

</style>
<style lang="less">
.syj_BlacktwoPrize {
  .lunkong {
    width: 100%;
    color: #fff;
    justify-content: center;
    margin-top: 20px;
  }
}
</style>
